export function getUniqueEventAttendees<Attendee extends { user_id: string; is_friend: boolean }>(
  attendees: Attendee[] | null | undefined
) {
  const seen = new Set<string>();
  return (attendees ?? [])
    .filter((attendee) => {
      if (seen.has(attendee.user_id)) {
        return false;
      }
      seen.add(attendee.user_id);
      return true;
    })
    .sort((a, b) => Number(b.is_friend) - Number(a.is_friend));
}
